module.exports = __webpack_public_path__ + "img/background.2e5ce115.png";